import React, { FC } from 'react'

import { IconEditProps } from './IconEdit.types'
import * as Styled from './styles/IconEdit.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEdit: FC<IconEditProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEditProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconEditProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M153 7a24.4 24.4 0 0 0-34.16 0l-15.52 15.51-.23.25-92.41 92.41A4 4 0 0 0 9.63 117L.12 155A4 4 0 0 0 5 159.88l38-9.46a4 4 0 0 0 1.87-1.06l92-92.57.24-.22 15.45-15.45a24.83 24.83 0 0 0 7.24-17.46A23.31 23.31 0 0 0 153 7zM40 142.93l-30.5 7.58L17.12 120l89.05-89 22.48 22.73zM147 35.46l-12.68 12.61-22.5-22.74 12.63-12.61a16.36 16.36 0 0 1 22.89 0 15.35 15.35 0 0 1 4.48 11 16.78 16.78 0 0 1-4.9 11.74z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconEdit
